import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { LookupService } from '../../../shared-app-portal/services/lookup.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TimeZoneModel } from '../models/timeZoneModel';

@Component({
  selector: 'app-lineup-timezone',
  templateUrl: './timezone.component.html',
  styleUrls: ['./timezone.component.scss'],
  standalone: false
})
export class TimeZoneComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  private _description: string;
  lineupTimeZones: TimeZoneModel[];
  isEditMode: boolean;
  editForm: FormGroup;
  displayName: string;
  @Input()
  public readOnly: boolean = false;
  @Input()
  public showSmallIcons: boolean = false;
  @Input()
  public label: string;
  @Input()
  public set description(value: string) {
    this._description = value;
    this.toggleEditMode(false);
  }
  @Output()
  public save = new EventEmitter<string>();
  @Output()
  public isEditModeChange = new EventEmitter<boolean>();
  constructor(
    private lookupService: LookupService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.isEditMode = false;
    this.subscription = this.lookupService.getTimeZones().subscribe((timeZones) => {
      this.lineupTimeZones = timeZones;
      this.displayName = this.displayDescription(this._description);
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  onSaveClicked() {
    let newDescription = this.editForm.get('description').value;
    if (newDescription === this._description) {
      this.toggleEditMode(false);
      return;
    }

    this.displayName = this.displayDescription(newDescription);
    this.save.emit(newDescription);
  }

  toggleEditMode(isEditMode: boolean) {
    this.isEditMode = isEditMode;
    if (this.isEditMode) {
      this.editForm = this.formBuilder.group({
        description: [this._description, Validators.required]
      });
    }
    this.isEditModeChange.emit(isEditMode);
  }

  private displayDescription(timeZoneName: string): string {
    return this.lineupTimeZones.find((tz) => tz.name === timeZoneName)?.displayName;
  }
}
